/* eslint-disable no-nested-ternary */
import React from 'react';
import styled from 'styled-components';
import { space, color } from 'styled-system';

const Label = styled.div`
  ${color}
  ${space}

  display: flex;
  flex-direction: row;
  width: fit-content;
  border-radius: 4px;
`;

function ItemTypeCard({ type, style }) {
  return (
    <Label
      mt="xs"
      px="xs"
      py="xxs"
      color="white"
      bg={type === 'ebook' ? 'blue_400' : type === 'audiobook' ? 'blue_500' : 'blue_300'}
      {...style}
    >
      {type}
    </Label>
  );
}

export default ItemTypeCard;
